<template>
  <div class="agree">
    <p class="ql-align-center">
      <strong style="background-color: transparent; color: black;">首信易支付用户服务协议</strong>
    </p>
    <p class="ql-align-center">
      <strong style="background-color: transparent; color: black;">(2019版)</strong>
    </p>
    <p class="ql-align-center"></p>
    <p class="ql-align-center">
      <br />
    </p>
    <p>
      <strong
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >易智付科技（北京）有限公司（以下简称 “首信易支付”）依据本协议为用户（以下简称“您”）提供支付结算服务。本协议对您和首信易支付均具有法律约束力。在使用首信易支付服务前，您应当仔细阅读并遵守本协议。首信易支付在此特别提醒您认真阅读并充分理解各条款，特别是免除或限制首信易支付的责任、限制您的权利、规定争议解决方式的相关条款。请您审慎阅读，如您对本协议有任何疑问，您可通过客服电话010-59321108或邮箱cs@payeasenet.com进行咨询。</strong>
    </p>
    <p>
      <strong
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >您理解并同意，首信易支付有权根据业务运营的调整需要，修订本协议的内容，并提前公告最新的协议，更新后的协议在公告届满30日起生效，若您无法同意更新后的协议内容，您有权停止使用首信易支付的服务。若您在协议生效后继续使用首信易支付服务的，表示您接受变更后的协议，也将遵循变更后的协议使用首信易支付服务。</strong>
    </p>
    <p>
      <strong style="background-color: transparent; color: black;">第一条 服务内容</strong>
    </p>
    <p>
      <br />
    </p>
    <p>
      <span
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >1.1首信易支付服务，指由首信易支付提供的依托首信易平台为收付款人之间提供货币资金转移的服务。该服务将嵌入您所注册的平台网站或移动客户端，实现该平台网站或移动客户端的收付款功能。您确认您了解该平台及平台服务商（以下简称“商户”），并同意成为该商户的用户。</span>
    </p>
    <p>
      <span style="background-color: transparent; color: rgb(0, 0, 0);">1.2首信易支付服务包括余额支付和快捷支付两种类型。</span>
    </p>
    <p>
      <span
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >1.2.1 余额支付，指您使用首信易支付为您开立的支付账户中的余额进行资金转移的一种支付方式。您有权使用您的首信易支付账户中的余额进行消费和转账，若余额不足，您需先开通快捷支付，并向您的首信易支付账户充值，您也可以通过接收他人的转账来增加您的首信易支付账户的余额。</span>
    </p>
    <p>
      <span
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >1.2.2 快捷支付，指您委托首信易支付直接对您的银行账户进行资金扣划和归集操作的一种支付方式。快捷支付可以实现对您的首信易支付账户的充值，以及消费、转账等功能。</span>
    </p>
    <p>
      <span
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >1.3 您同意首信易支付依据您的支付指令（通过商户平台转发给首信易支付的系统）及支付密码（由您预先设置）即可直接从您绑定的银行卡进行扣款，您通过商户向首信易支付发送支付指令及支付密码的行为即视为您对首信易支付进行授权，无需您事先通过其他方式进行授权确认。</span>
    </p>
    <p>
      <strong style="background-color: transparent; color: black;">第二条 相关定义</strong>
    </p>
    <p></p>
    <p>
      <br />
    </p>
    <p>
      <span
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >2.1 首信易支付账户（或称“账户”）：指您通过首信易支付身份验证后取得的供您使用首信易支付服务的支付账户。</span>
    </p>
    <p>
      <span
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >2.2 身份要素:指首信易支付用于识别您身份的信息要素，包括但不限于您的首信易支付账户、密码、数字证书、短信校验码、支付盾、电话号码、手机号码、身份证件号码及指纹信息、人脸信息、眼纹信息等。</span>
    </p>
    <p>
      <span
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >2.3 有权机关：指依照法律法规等有权要求采取查询、冻结或扣划资金等措施的单位，包括但不限于公安机关、检察院、法院、海关、税务机关等。</span>
    </p>
    <p>
      <span
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >2.4 冻结：指有权机关要求的冻结。被冻结余额不能用于支付、提现或转账等，被冻结账户不可登录、使用。</span>
    </p>
    <p>
      <span
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >2.5 限制：指除冻结情况之外，您的首信易支付账户部分或全部功能不能使用，或账户相关资产、账户余额、第三方提供的授信额度不能使用。</span>
    </p>
    <p>
      <span
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >2.6 止付：限制措施的一种，指您的首信易支付账户余额不能使用，例如不能用于支付、提现或转账等服务。</span>
    </p>
    <p>
      <strong style="background-color: transparent; color: black;">第三条 账户功能</strong>
    </p>
    <p>
      <br />
    </p>
    <p>
      <span style="background-color: transparent; color: rgb(0, 0, 0);">3.1 支付账户开立</span>
    </p>
    <p>
      <span
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >首信易支付可根据您的需要及《 非银行支付机构网络支付业务管理办法》等规范的相关要求，为您开立支付账户，并提供相关必要的信息查询、技术支持等服务，具体以首信易支付实际提供的为准。主要流程包括：</span>
    </p>
    <p>
      <span
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >3.1.1 您应在首信易支付网站或客户端页面如实填写、提供身份基本信息。</span>
    </p>
    <p>
      <span
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >3.1.2首信易支付按照实名制管理要求，登记并采取有效措施验证您身份信息，按照规定核对有效身份证件并留存有效身份证件复印件或者影印件，建立用户唯一识别编码，有效核实您的身份及真实意愿后，首信易支付应依据身份核验方式的不同为您开立相应余额付款功能的支付账户。您在账户中设置的昵称、头像、签名、留言等请务必遵守法律法规、公序良俗、社会公德，且不会侵害其他第三方的合法权益，否则您将独自承担上述责任，并且首信易支付有权取消、限制您的账户，或直接修改您的昵称、头像、签名等。</span>
    </p>
    <p>
      <span
        style="background-color: transparent; color: black;"
      >I 类账户: 以非面对面方式通过至少一个外部渠道验证身份，可用于消费及转账，自账户开立起累计不超过 1000 元（包括支付账户向客户本人同名银行账户转账）。</span>
    </p>
    <p>
      <span
        style="background-color: transparent; color: black;"
      >II 类账户：自主或委托合作机构以面对面验证身份，或以非面对面方式通过至少三个外部渠道验证身份，可用于消费及转账，年累计不超过 10 万元 （不包括支付账户向客户本人同名银行账户转账）。</span>
    </p>
    <p>
      <span
        style="background-color: transparent; color: black;"
      >III 类账户：自主或委托合作机构以面对面验证身份，或以非面对面方式通过至少五个外部渠道验证身份，可用于消费、转 账、投资理财，年累计不超过 20 万元 （不包括支付账户向客户本人同名银行账户转账）。</span>
    </p>
    <p>
      <strong
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >3.1.3 为了满足法律法规关于非银行支付机构的运营规定，您授权首信易支付向国家机关、金融机构、企事业单位查询、核实您的身份信息、账户信息等。</strong>
    </p>
    <p>
      <span
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >3.1.4 为了维护良好的网络环境，首信易支付有权了解您使用首信易支付服务的真实背景及目的，您对此知悉并认可，如我们要求您提供相关信息或资料的，请您予以配合。</span>
    </p>
    <p>
      <strong
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >3.1.5 一旦您在“同意《用户服务协议》《隐私政策》”前勾选，并完成支付账户开立流程，即表示您同意开立首信易支付支付账户。</strong>
    </p>
    <p>
      <strong style="background-color: transparent; color: black;">3.2 支付账户的功能</strong>
    </p>
    <p></p>
    <p>
      <strong style="background-color: transparent; color: black;">A：充值</strong>
    </p>
    <p>
      <span
        style="background-color: transparent; color: black;"
      >在您成功绑定您名下的银行卡后，您可以将您关联的银行账户中的资金划转至您的首信易支付账户。</span>
    </p>
    <p></p>
    <p>
      <strong style="background-color: transparent; color: black;">B：提现</strong>
    </p>
    <p>
      <span
        style="background-color: transparent; color: black;"
      >您可以将您的首信易支付账户内余额划转至您绑定的银行卡账户中。除被冻结或其他限制款项外，首信易支付将于收到提现指令后的合理时间内，将相应款项汇入该银行账户。此外，首信易支付可能会对提现进行风险审查，因此可能导致提现延迟。</span>
    </p>
    <p>
      <br />
    </p>
    <p>
      <strong style="background-color: transparent; color: rgb(0, 0, 0);">C：转账/收款</strong>
    </p>
    <p>
      <strong style="background-color: transparent; color: rgb(0, 0, 0);">转账：</strong>
      <span
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >您可以使用首信易支付服务向您指定的收款人转账，首信易支付将根据您的支付指令，从您的首信易支付账户或您关联的银行账户扣划相应资金至收款人的首信易支付账户或银行账户。您在使用转账服务时，请谨慎核对收款方信息（包括但不限于收款方的真实身份信息等）以免受到损失。</span>
    </p>
    <p>
      <strong style="background-color: transparent; color: rgb(0, 0, 0);">收款：</strong>
      <span
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >您也可以通过首信易支付服务收取他人的转账资金，首信易支付可将该笔资金转至您的首信易支付账户。您也可以将您的首信易支付账户内的资金转移至您关联的银行账户，首信易支付也可按照法律规定或本协议约定直接将您的首信易支付账户内的资金转移至您关联的银行账户。</span>
    </p>
    <p>
      <strong
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >首信易支付将通过客户端中的“红包”、“转账”功能实现转账和收款功能。</strong>
    </p>
    <p>
      <strong style="background-color: transparent; color: black;">D：消费</strong>
    </p>
    <p>
      <span
        style="background-color: transparent; color: black;"
      >您可以通过您的首信易支付账户余额购买首信易支付商户的网站或移动客户端提供的商品或服务，消费完成后您的首信易支付账户余额自动扣减相应金额。</span>
    </p>
    <p></p>
    <p>
      <strong style="background-color: transparent; color: black;">E：查询</strong>
    </p>
    <p>
      <span
        style="background-color: transparent; color: black;"
      >首信易支付将记录您使用首信易支付服务的情况，您可以在客户端查询交易情况。</span>
    </p>
    <p></p>
    <p>
      <strong style="background-color: transparent; color: black;">F：添加/解绑银行卡</strong>
    </p>
    <p>
      <span
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >您可以在您所使用的客户端我的银行卡功能项下关联新的银行账户、银行卡或解绑银行账户、银行卡。</span>
    </p>
    <p></p>
    <p>
      <strong style="background-color: transparent; color: black;">G：修改/重置密码</strong>
    </p>
    <p>
      <span
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >您可以对原有密码进行修改，或通过提供银行卡及个人信息等资料申请密码重置。</span>
    </p>
    <p>
      <br />
    </p>
    <p>
      <strong
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >基于运行和交易安全的需要，首信易支付可能会暂停或者限制首信易支付服务部分功能，或增加新功能。</strong>
    </p>
    <p>
      <strong style="background-color: transparent; color: rgb(0, 0, 0);">3.3 支付账户的注销</strong>
    </p>
    <p class="ql-align-justify">
      <span
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >3.3.1您所申请注销的首信易支付账户应当是您依照本协议的约定注册并由首信易支付提供给您本人的账户。您应当依照首信易支付规定的程序或网站上的提示进行首信易支付账户注销。</span>
    </p>
    <p class="ql-align-justify">
      <span
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >3.3.2首信易支付账户注销将导致首信易支付终止为您提供服务，本协议约定的双方的权利义务终止（依本协议其他条款另行约定不得终止的或依其性质不能终止的除外），同时还可能对于该账户产生如下结果：</span>
    </p>
    <p class="ql-align-justify">
      <strong style="background-color: transparent; color: rgb(0, 0, 0);">A、您的帐户余额将被清空无法恢复；</strong>
    </p>
    <p class="ql-align-justify">
      <strong style="background-color: transparent; color: rgb(0, 0, 0);">B、所有历史交易信息将被清空并无法恢复；</strong>
    </p>
    <p class="ql-align-justify">
      <strong
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >C、所有与您的首信易支付帐户相关的服务将无法继续使用。</strong>
    </p>
    <p class="ql-align-justify">
      <span
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >3.3.3您申请注销的首信易支付账户应当处于正常状态，且该账户可以使用所有首信易支付服务功能的状态。被冻结的账户不能被申请注销。</span>
    </p>
    <p class="ql-align-justify">
      <span
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >3.3.4如果您的首信易支付账户在连续三年内没有任何账户操作行为或资金变动，且满足本协议规定的其他注销条件时，首信易支付有权依照本协议的规定或国家相关法律法规的要求主动进行注销，由此引发的一切后果由您本人承担。&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
    </p>
    <p class="ql-align-justify">
      <span
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >3.3.5您申请注销的首信易支付账户应当不存在任何由于该账户被注销而导致的未了结的合同关系与其他基于该账户的存在而产生或维持的权利义务，及首信易支付认为注销该账户会由此产生未了结的权利义务而产生纠纷的情况。&nbsp;</span>
    </p>
    <p class="ql-align-justify">
      <span
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >3.3.6您同意，如您申请注销首信易支付账户时，首信易支付尚在或需要对您的有关交易或账户进行核查时，有权继续冻结您的首信易支付账户或账户内全部或部分资金以便继续核查，并在必要时有权向监管或司法部门举报欺诈或非法行为。</span>
    </p>
    <p>
      <strong style="background-color: transparent; color: black;">第四条 服务费用</strong>
    </p>
    <p>
      <br />
    </p>
    <p>
      <strong
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >您理解，首信易支付服务附带营运成本，为了持续营运，首信易支付有权向您收取服务费用，您同意首信易支付可从您的交易款中直接扣除相关费用。首信易支付发出的有关收费的各类通知、告知均为本协议的组成部分，各类通知、公告确定的服务费用标准自通知、公告届满30日起生效，若您无法同意通知、公告确定的服务费用标准，您有权停止使用首信易支付服务。</strong>
    </p>
    <p>
      <strong style="background-color: transparent; color: black;">第五条 风险提示及特别约定</strong>
    </p>
    <p>
      <br />
    </p>
    <p>
      <strong
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >5.1 您已知悉，支付账户所记录的资金余额不同于用户本人的银行存款，不受《存款保险条例》保护，其实质为用户委托首信易支付保管的、所有权归属于用户的预付价值。该预付价值对应的货币资金虽然属于用户，但不以用户本人名义存放在银行，而是以首信易支付名义存放在银行，并且由首信易支付向银行发起资金调拨指令。</strong>
    </p>
    <p>
      <strong
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >5.2 您充分知悉，网上交易有风险，您与他人因网上交易产生的商品或服务质量、数量、交易金额、交货时间等纠纷及损失，应由您独立承担责任。</strong>
    </p>
    <p>
      <strong
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >5.3 如您为无民事行为能力人或为限制民事行为能力人，请暂不要申请用户注册，或请告知监护人，并在监护人的指导下阅读本协议和使用首信易支付服务。因此所发生的一切后果将由您及您的监护人负责，首信易支付不承担任何责任。</strong>
    </p>
    <p>
      <strong
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >5.4若您非中华人民共和国境内（为本协议之目的，不包括香港、澳门特别行政区及台湾地区）用户，您还需同时遵守您所属国家或者地区的法律、法规、政策等相关规章制度，且您确认，订立并履行本协议不违反您所属、所居住或开展经营活动或其他业务的国家或地区的法律法规。</strong>
    </p>
    <p>
      <strong
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >5.5 您在使用首信易支付服务时，应自行谨慎判断对方是否是完全民事行为能力人，并自行决定是否与对方进行交易或转账给对方等，且您应自行承担与此相关的所有风险。为了保障您的资金安全，首信易支付将根据您的首信易支付账户的风险管理情况设置转账日限额和笔数，或您自行设置的日限额和笔数进行转账，超出限额和笔数的，首信易支付将不再办理转账业务。</strong>
    </p>
    <p>
      <strong
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >5.6 您在申请开立支付账户时，应向首信易支付如实提供详细、准确、完整的相关材料，并保证上述提交资料的合法性、真实性、准确性和完整性。若您提供的资料有任何错误、不实、过时或不完整的情况，首信易支付有权利暂停您的首信易支付账户相关服务，由此产生的任何直接或间接的损失，由您自行承担。同时，您应根据及时、详细、准确的原则不断更新您的资料。如果因为您未及时更新资料导致有关操作不能完成或发生错误，由此产生的一切后果由您自行承担。</strong>
    </p>
    <p>
      <strong
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >5.7 您应准确提供并及时更新您的联系方式，以便首信易支付与您进行及时、有效联系；如您未准确提供并及时更新您的联系方式，首信易支付可能将无法与您取得联系，并无法为您提供部分或全部服务。</strong>
    </p>
    <p>
      <strong
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >5.8 您授权首信易支付有权根据中国人民银行等监管机构的要求将您提供的个人信息提交第三方机构进行识别，这些信息包括但不限于您本人的身份信息、联系方式、职业和居住地址等个人基本信息，个人贷款、各类信用卡和对外担保等信用及在商业活动中形成的各类交易记录，个人信贷交易信息及公共费用缴纳、违法违规信息及非银行类信息等。您知晓并同意自行承担因此产生的一切法律后果。</strong>
    </p>
    <p>
      <strong
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >5.9 为了防止您的资金、个人信息被不法分子获取，您同意首信易支付收集您的下列信息以判断您支付的风险。当您使用首信易支付服务时，首信易支付可能会记录您使用的服务类别和方式、使用服务时的操作信息，如您的IP地址、移动设备使用的版本和设备识别码、设备标识符、您的位置以及其他与首信易支付服务相关的日志信息等。</strong>
    </p>
    <p>
      <strong
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >5.10 如您不按照支付提示操作、未及时进行支付操作、遗忘或泄漏密码、密码被他人破解、您使用的手机或计算机等终端被他人侵入等原因导致损失的，您应自行承担责任。</strong>
    </p>
    <p>
      <strong
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >5.11 您不得利用首信易支付服务进行任何形式的洗钱、虚假交易、资金非法套现及其它违法行为。若首信易支付发现您违反本约定的，首信易支付有权立即暂停、中止或终止提供服务，向公安部门报案，且将相关信息报送有关部门。 由此产生的责任由您独自承担，若您因此给首信易支付造成损失的，您还须赔偿首信易支付的全部损失。</strong>
    </p>
    <p>
      <strong
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >5.12 您不得把您的首信易支付账户用于本协议约定范围以外的其他用途，也不得出租、转让、出借、赠予、继承给第三方使用。但首信易支付账户内的相关财产权益可以被依法继承。非因首信易支付原因导致第三方使用您的首信易支付账户造成您的损失的，由您个人承担，给首信易支付造成损失的，您还须赔偿首信易支付因此遭受的全部损失。</strong>
    </p>
    <p>
      <strong
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >5.13如您发现有他人冒用或者盗用您的首信易支付账户、标识、或者登录名及密码，或者您的手机或者其他设备丢失时，请您立即以有效方式通知我们；您还可以向我们申请暂停或停止首信易支付服务。由于我们对您的请求采取行动需要合理时间，我们对采取行动之前已执行的指令免于承担责任。</strong>
    </p>
    <p>
      <strong
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >5.14 您使用首信易支付服务时，应确保自身发出支付指令的合法性、真实性、有效性和完整性。您同意首信易支付按您的支付指令完成操作后，相关资金的任何风险和责任由您自行承担。</strong>
    </p>
    <p>
      <strong
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >5.15 您理解并同意，因资金划转的及时性，支付指令一旦发出即立即生效、不可撤销，首信易支付有权根据您发出的支付指令进行资金扣划和归集操作。您应妥善保管您的手机等电子设备、支付密码、短信校验码、数字证书、电子签名等信息和资料，因您自身泄露、遗失、复制、转交前述信息和资料而导致的损失，由您自行承担。</strong>
    </p>
    <p>
      <strong
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >5.16 您理解并同意，首信易支付并非银行或金融机构，无法提供资金即时到账服务，您认可资金于途中流转需要合理时间。</strong>
    </p>
    <p>
      <strong
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >5.17 您使用首信易支付服务期间，您仅在首信易支付代为收取或者代为支付款项（不含被有权机关冻结、止付或其他限制的款项）的金额范围内享有支配的权利。首信易支付无须对为您保管、代收或代付款项的货币贬值、汇率损失和利息损失及其他风险担责，并且首信易支付无需向您支付此等款项的孳息。</strong>
    </p>
    <p>
      <strong
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >5.18 您的首信易支付账户连续3个月无交易，首信易支付有权暂停为您提供本服务，待重新核实身份后，可以恢复服务；连续12个月无交易的，首信易支付有权终止为您提供服务。</strong>
    </p>
    <p>
      <strong
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >5.19您使用首信易支付服务时，应当仔细确认交易及其金额后进行支付。首信易支付有权根据您的指令扣划资金给收款人，届时您不应以未在交易单据中签名、签名不符、非本人意愿交易等原因要求首信易支付退款或承担其他责任。</strong>
    </p>
    <p>
      <strong
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >5.20 您同意首信易支付有权以电子邮件、公告、电话或传真等方式通知您关于使用首信易支付服务的信息。</strong>
    </p>
    <p>
      <strong
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >5.21 您需要遵守中华人民共和国相关法律法规及您所属、所居住或开展经营活动或其他业务的国家或地区的法律法规。您不得利用首信易支付服务实施下列侵害他人合法权益之行为或者违反国家法律法规之行为，也不得以非法方式使用首信易支付的服务或将首信易支付服务用于非法目的。</strong>
    </p>
    <p>
      <strong
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >&nbsp;&nbsp;&nbsp;&nbsp; （1） 反对宪法所确定的基本原则，危害国家安全、泄漏国家秘密、颠覆国家政权、破坏国家统一；</strong>
    </p>
    <p>
      <strong
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >&nbsp;&nbsp;&nbsp;&nbsp; （2） 侵害他人名誉、隐私权、商业秘密、商标权、著作权、专利权及其他权利；</strong>
    </p>
    <p>
      <strong
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >&nbsp;&nbsp;&nbsp;&nbsp; （3） 冒用他人名义使用首信易支付服务或您提交的电话号码与身份证号无法通过校验的；</strong>
    </p>
    <p>
      <strong
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >&nbsp;&nbsp;&nbsp;&nbsp; （4） 从事任何不法交易行为，如恐怖融资、贩卖枪支、毒品、禁药、盗版软件、黄色淫秽物品、在网上买卖POS机（包括MPOS）、刷卡器等受理终端、发布或者销售伪劣商品，或贩卖其他违禁物的行为；</strong>
    </p>
    <p>
      <strong
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >&nbsp;&nbsp;&nbsp;&nbsp; （5） 提供赌博资讯或以任何方式引诱他人参与赌博；</strong>
    </p>
    <p>
      <strong
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >&nbsp;&nbsp;&nbsp;&nbsp; （6） 涉嫌实施或实施洗钱、套现或进行传销活动；</strong>
    </p>
    <p>
      <strong
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >&nbsp;&nbsp;&nbsp;&nbsp; （7）使用无效信用卡或未经授权使用他人信用卡进行交易、套取现金等；</strong>
    </p>
    <p>
      <strong
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >&nbsp;&nbsp;&nbsp;&nbsp; （8） 使用无效银行账户或他人银行账户进行交易；</strong>
    </p>
    <p>
      <strong
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >&nbsp;&nbsp;&nbsp;&nbsp; （9） 从事可能侵害首信易支付服务系統、数据的行为；</strong>
    </p>
    <p>
      <strong
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >&nbsp;&nbsp;&nbsp;&nbsp; （10） 违反法律法规、监管规定、本协议、规则、通告等相关规定；</strong>
    </p>
    <p>
      <strong
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >&nbsp;&nbsp;&nbsp;&nbsp; （11） 出租、出借、出售、购买银行账户或者支付账户，假冒他人身份或者虚构代理关系开立银行账户或者支付账户；</strong>
    </p>
    <p>
      <strong
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >（12）进行与您或交易对方宣称的交易内容不符的交易，或者不真实的交易；</strong>
    </p>
    <p>
      <strong
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >（13）从事其他违反国家法律、法规、规章及监管政策的行为，或其他违反本协议或违反保密义务的行为。</strong>
    </p>
    <p>
      <strong
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >一旦出现上述违反法律法规或首信易支付规则的行为。我们有权进行调查、延迟、拒绝结算或者停止提供服务，注销您名下的用户标识或账户，且您需要自行承担相关法律责任，如因此导致首信易支付或者其他方受损的，您需要承担赔偿责任。</strong>
    </p>
    <p>
      <strong
        style="background-color: transparent; color: black;"
      >5.22 您不得直接或变相从事互联网赌博、色情平台，互联网销售彩票平台，非法外汇、贵金属投资交易平台，非法证券期货类交易平台，代币发行融资及虚拟货币交易平台，也不得未经监管部门批准通过互联网开展资产管理业务以及未取得省级政府批文的大宗商品交易场所等非法交易，否则首信易支付有权终止为您提供服务。</strong>
    </p>
    <p>
      <strong
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >5.23 您对首信易支付所提示的风险和列示措施、说明完全理解和同意，承诺采取相关风险防范措施以尽量避免或减小风险，您自愿承担交易风险及损失。</strong>
    </p>
    <p>
      <strong
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >5.24 您理解，我们服务有赖于系统的准确运营及操作。若出现系统差错、故障、您或我们不当获利等情形，您同意我们可以采取更正差错、扣划款项等适当纠正措施。</strong>
    </p>
    <p>
      <strong
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >5.25 您不得对首信易支付系统和程序采取反向工程手段进行破解，不得对上述系统和程序（包括但不限于源程序、目标程序、技术文档、客户端至服务器端的数据、服务器数据）进行复制、修改、编译、整合或者篡改，不得修改或者增减首信易支付系统的功能。</strong>
    </p>
    <p>
      <strong style="background-color: transparent; color: rgb(0, 0, 0);">第六条 隐私权保护</strong>
    </p>
    <p>
      <span
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >首信易支付重视对您的隐私的保护。关于您的身份资料和其他特定资料依《首信易支付隐私政策》受到保护与规范。</span>
    </p>
    <p>
      <strong style="background-color: transparent; color: rgb(0, 0, 0);">第七条 知识产权条款</strong>
    </p>
    <p>
      <span
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >7.1首信易支付提供的网络服务内容包括：文字、软件、声音、图片、录象、图表、广告中的全部内容；电子邮件的全部内容；首信易支付为用户提供的其他信息。所有这些内容的版权、商标、专利、专有技术和所有权等权利受法律保护，知识产权归首信易支付及其关联公司所有。</span>
    </p>
    <p>
      <span
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >7.2非经首信易支付或关联公司书面同意，请勿擅自使用、修改、反向编译、复制、公开传播、改变、散布、发行或公开发表首信易支付的程序或内容。尊重知识产权是您应尽的义务。如有违反，您需要承担损害赔偿责任。</span>
    </p>
    <p>
      <strong
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >7.3 您因履行本协议需要使用以上权利的，应经首信易支付明确的书面许可。首信易支付的书面授权不构成任何形式的权利转让。</strong>
    </p>
    <p>
      <strong style="background-color: transparent; color: rgb(0, 0, 0);">第八条 不可抗力及免责条款</strong>
    </p>
    <p>
      <span
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >8.1 您在使用首信易支付服务的过程中，可能会遇到不可抗力等风险因素，使服务发生中断。不可抗力是指不能预见、不能克服、不能避免且对一方或双方造成重大影响的客观事件，包括但不限于洪水、地震、瘟疫和风暴等自然灾害以及战争、动乱、政府行为等社会事件。出现上述情况时，首信易支付将努力在第一时间与相关单位配合及时进行修复。</span>
    </p>
    <p>
      <strong
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >8.2 在法律允许的范围内，首信易支付对以下情形导致的服务中断或受阻不承担责任：</strong>
    </p>
    <p>
      <strong
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >&nbsp;&nbsp;&nbsp;&nbsp; （1） 受到计算机病毒、木马或其他恶意程序、黑客攻击、网络拥堵、系统不稳定等造成的破坏；</strong>
    </p>
    <p>
      <strong
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >&nbsp;&nbsp;&nbsp;&nbsp; （2） 电脑软件、系统、硬件和通信线路、电力、设备出现故障；</strong>
    </p>
    <p>
      <strong
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >&nbsp;&nbsp;&nbsp;&nbsp; （3） 您操作不当；</strong>
    </p>
    <ol>
      <li>
        <strong style="background-color: transparent;">您通过非首信易支付授权的方式使用首信易支付服务；</strong>
      </li>
    </ol>
    <p>
      <br />
    </p>
    <p>
      <strong
        style="background-color: transparent; color: black;"
      >（5）因银行等金融机构或组织的原因 、第三方服务瑕疵、政府行为、监管政策等非首信易支付原因导致的事件</strong>
      <strong style="background-color: transparent; color: rgb(0, 0, 0);">；</strong>
    </p>
    <p>
      <strong style="background-color: transparent; color: black;">（6）首信易支付的系统停机维护或者升级。</strong>
    </p>
    <p>
      <strong style="background-color: transparent; color: black;">（7）因台风、地震、洪水、雷电或恐怖袭击等不可抗力原因；</strong>
    </p>
    <p>
      <strong style="background-color: transparent; color: rgb(0, 0, 0);">（8） 其他首信易支付无法控制或合理预见的情形。</strong>
    </p>
    <p>
      <strong
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >8.3 您在使用首信易支付服务的过程中，首信易支付不对下列风险承担责任：</strong>
    </p>
    <p>
      <strong
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >&nbsp;&nbsp;&nbsp;&nbsp; （1） 来自他人匿名或冒名的含有威胁、诽谤、令人反感或非法内容的信息；</strong>
    </p>
    <p>
      <strong
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >&nbsp;&nbsp;&nbsp;&nbsp; （2） 遭受他人误导、欺骗或其他原因而导致的任何心理、生理上的伤害以及经济上的损失；</strong>
    </p>
    <p>
      <strong style="background-color: transparent; color: rgb(0, 0, 0);">（3） 其他因网络信息或您自身行为引起的风险。</strong>
    </p>
    <p>
      <strong style="background-color: transparent; color: rgb(0, 0, 0);">第九条 适用法律及争议解决</strong>
    </p>
    <p>
      <strong
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >9.1 本协议的解释、适用、争议解决等一切事宜，均适用中华人民共和国法律（香港特别行政区、澳门特别行政区和台湾地区的法律除外）。</strong>
    </p>
    <p>
      <strong
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >9.2 因本协议产生任何纠纷时，应友好协商，协商不成的，您同意将争议提交至首信易支付住所地（北京市朝阳区）有管辖权的人民法院诉讼解决。</strong>
    </p>
    <p></p>
    <p>
      <strong style="background-color: transparent; color: black;">第十条 暂停、中止或终止服务</strong>
    </p>
    <p>
      <br />
    </p>
    <p>
      <strong
        style="background-color: transparent; color: black;"
      >10.1 在本协议有效期内，如您违反法律法规或本协议的约定，或首信易支付发现您的账户交易异常（包括但不限于您收支与正常交易活动相异或者相关业务模式存在风险等）或有可疑交易时，首信易支付有权不经通知先行暂停、中止或终止向您提供服务。若首信易支付</strong>
      <strong
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >决定终止向您提供全部或部分服务，首信易支付有权将您的首信易支付账户中的合法资金退回到您绑定的银行账户。</strong>
    </p>
    <p>
      <strong
        style="background-color: transparent; color: black;"
      >10.2 您同意，发生下列情形之一的，首信易支付无需进行事先通知即可暂停、中止或终止向您提供服务，同时，首信易支付有权按本协议的约定冻结您名下全部或部分账户资金，或暂停执行您发送的部分或全部指令。</strong>
    </p>
    <p>
      <strong
        style="background-color: transparent; color: black;"
      >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; （1）您提供的个人资料不真实，且未能提供合理说明及证明；</strong>
    </p>
    <p>
      <strong
        style="background-color: transparent; color: black;"
      >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; （2）您涉嫌违反相关法律、法规、规章及政府规范性文件；</strong>
    </p>
    <p>
      <br />
    </p>
    <p>
      <strong
        style="background-color: transparent; color: black;"
      >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; （3）根据相关法律法规或者中国人民银行、银保监会等金融监管机关、公安机关、检察机关、审判机关、监察机关、海关、税务等有权机关向首信易支付发出要求；</strong>
    </p>
    <p>
      <strong
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >（4）他人向您首信易支付账户错误汇入资金等导致您可能存在不当获利的；</strong>
    </p>
    <p>
      <strong style="background-color: transparent; color: rgb(0, 0, 0);">（5）您遭到他人投诉，且对方已经提供了一定证据的；</strong>
    </p>
    <p>
      <br />
    </p>
    <p>
      <strong
        style="background-color: transparent; color: black;"
      >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; （6）其他本协议约定的情形。</strong>
    </p>
    <p>
      <strong
        style="background-color: transparent; color: black;"
      >首信易支付按照上述规定采取冻结措施后，如您申请解冻，首信易支付有权自行判断且根据前述冻结原因以及您提供的申请解冻原因来决定是否允许全部或部分解冻，您应充分理解您的解冻申请并不必然被允许，且申请解冻时您应当配合首信易支付核实您的身份，提供包括但不限于身份信息、身份证、护照、其他有效的身份证明文件，资金来源证明，交易证明及首信易支付要求的其他信息或文件。</strong>
    </p>
    <p>
      <strong
        style="background-color: transparent; color: black;"
      >10.3 您理解并同意，首信易支付有权按照公安、检察、法院、海关、税务及其他有权机关的要求对您的首信易支付账户进行查询、冻结或扣划。</strong>
    </p>
    <p>
      <strong
        style="background-color: transparent; color: black;"
      >10.4 您理解并同意，首信易支付有权根据有效法律文书（包括但不限于生效的法院判决、仲裁裁决书、行政决定书等）的内容处置与您的首信易支付账户相关的款项和交易。</strong>
    </p>
    <p>
      <strong
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >10.5 您理解并同意，首信易支付有权自主决定经营策略。在符合法律法规的前提下，在首信易支付发生合并、分立、收购、资产转让等经营变更情形时，首信易支付有权自主向第三方转让本服务及其相关资产；首信易支付也可在单方通知您后，将本协议下部分或全部服务转交由第三方运营或履行。具体受让主体以首信易支付的通知为准。</strong>
    </p>
    <p>
      <strong style="background-color: transparent; color: rgb(0, 0, 0);">第十一条 第三方投诉处理</strong>
    </p>
    <p>
      <strong
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >您使用首信易支付服务时不得有违反国家法律法规、侵害他人合法权益的行为。您理解并同意，如您被他人投诉或您投诉他人，首信易支付有权将您的主体信息、联系方式、投诉相关的内容等必要信息提供给争议相对方或相关部门，以便及时解决投诉纠纷，以保护您及他人的合法权益；但法律法规另有规定的除外。</strong>
    </p>
    <p>
      <strong style="background-color: transparent; color: rgb(0, 0, 0);">第十二条 用户承诺</strong>
    </p>
    <p>
      <strong
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >12.1 您承诺，发起的交易基于真实的交易背景，不得利用首信易支付提供的服务进行虚假交易。</strong>
    </p>
    <p>
      <strong
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >12.2 您承诺，您已充分了解并清楚知晓出租、出借、出售、购买账户的相关法律责任和惩戒措施,承诺依法依规开立和使用您的首信易支付账户。</strong>
    </p>
    <p>
      <strong style="background-color: transparent; color: rgb(0, 0, 0);">第十三条 其他条款</strong>
    </p>
    <p>
      <span
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >13.1 本协议所有条款的标题仅为阅读方便，本身并无实际涵义，不能作为本协议涵义解释的依据。</span>
    </p>
    <p>
      <span
        style="background-color: transparent; color: rgb(0, 0, 0);"
      >13.2 本协议条款无论因何种原因部分无效或不可执行，其余条款仍有效，对双方具有约束力。</span>
    </p>
    <p class="ql-align-right">
      <span style="background-color: transparent; color: rgb(0, 0, 0);">易智付科技（北京）有限公司</span>
    </p>
    <p>
      <br />
    </p>
  </div>
</template>

<script>
export default {
  name: "SYService",
  created(){
      document.title = "首信易支付用户服务协议"
  }
};
</script>

<style>
.agree {
  line-height: 1.5;
  padding:10px;
  font-size: 15px;
}
</style>
